import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';
import { ShowrightDirective } from '../../../directives/animations/showright.directive';

@Component({
  selector: 'section[app-about-rhythm-section]',
  imports: [
    NgOptimizedImage,
    ShowleftDirective,
    ShowrightDirective,
  ],
  templateUrl: './about-rhythm-section.html',
  styleUrl: './about-rhythm-section.scss',
})
export class AboutRhythmSection {
}
